import type { SubscriptionAdvertisement } from '../@types/AdvertismentSubscription';
import type { ElasticVehicle } from '../@types/ElasticVehicle';
import { getMarket } from '../i18n';

export class Subscription {
  static parseAdvertisementSubscription = ({
    id,
    namespace,
    name,
    advertisementId,
    title,
    shortDescription,
    image,
    mileage,
    price,
    leasingPrice,
    manufactureYear,
    modelYear,
    fuelType,
    gearboxType,
    sellerName,
    branchName,
    city,
    latitude,
    longitude,
    createdAt,
    updatedAt,
    lastNotifiedAt,
    isActive,
  }: SubscriptionAdvertisement): SubscriptionAdvertisement => ({
    id,
    namespace,
    name,
    advertisementId,
    title,
    shortDescription,
    image,
    mileage,
    price,
    leasingPrice,
    manufactureYear,
    modelYear,
    fuelType,
    gearboxType,
    sellerName,
    branchName,
    city,
    latitude,
    longitude,
    createdAt,
    updatedAt,
    lastNotifiedAt,
    isActive,
  });

  static convertToSearchItem = ({
    advertisementId,
    title,
    shortDescription,
    image,
    mileage,
    price,
    leasingPrice,
    manufactureYear,
    modelYear,
    fuelType,
    gearboxType,
    branchName,
    city,
    latitude,
    longitude,
  }: SubscriptionAdvertisement): ElasticVehicle => {
    const featuredImage = image
      ? {
          files: [
            {
              formats: [
                {
                  format: '380x253',
                  id: '',
                  url: image,
                },
              ],
              id: '',
              sortOrder: 1,
              url: image,
            },
          ],
          id: '',
          sortOrder: 1,
          type: 'image',
        }
      : undefined;

    return {
      branches: [
        {
          id: '',
          name: branchName,
          isCentralStorage: false,
          authorizedResellerForManufacturer: false,
          city: '',
          connectedBranches: [],
          latitude: 0,
          longitude: 0,
          slug: '',
        },
      ],
      deductibleVat: false,
      enginePower: 0,
      featuredImage,
      fuelType,
      gearboxType,
      hasManufacturerPackaging: false,
      id: advertisementId,
      isAuctionItem: false,
      itemCreated: '',
      itemPublished: '',
      leasingPrice,
      manufactureYear: manufactureYear ?? 0,
      manufacturer: '',
      mediaTypes: [],
      mileage: mileage ?? 0,
      modelSeries: '',
      modelYear: modelYear ?? 0,
      oldPrice: 0,
      position: {
        city,
        location: {
          lat: latitude || 0,
          lon: longitude || 0,
        },
        zip: '',
        street: '',
      },
      price,
      properties: { colorName: '' },
      shortDescription,
      title,
      baseEngineType: '',
      businessLeasingPrice: 0,
      commerce: {
        enabled: false,
        disabledOnWayke: false,
        allowTradeIn: false,
        homeDelivery: false,
        reserved: false,
      },
      contactOptions: {
        email: '',
        avatarUrl: '',
        displayName: '',
        id: '',
        telephone: '',
        title: '',
      },
      description: '',
      electricalRangeWLTP: 0,
      financialOptions: [],
      fuelTypes: '',
      gearbox: '',
      hasMrfPackaging: false,
      insuranceOptions: [],
      isDemoVersion: false,
      itemSort: '',
      leasingPromos: [],
      media: [],
      modelName: '',
      odometerReading: {
        unit: getMarket().marketCode === 'SE' ? 'mil' : 'km',
        value: (mileage ?? 0) / (getMarket().marketCode === 'SE' ? 1 : 10),
      },
      options: [],
      paymentOptions: [],
      registrationNumber: '',
      resellerPackagingOptions: [],
      sellerType: '',
      users: [],
      accessories: [],
      availableFrom: '',
      document: [],
      externalUrl: '',
    };
  };
}

export default Subscription;
